import React from "react";
import { Switch, Redirect } from "react-router-dom";
import {
  Investment,
  AddMasterInvestment,
  TradeCustodian,
  CustodianDetail,
  AddTradeCustodian,
  RKAS,
  TrialBalance,
  Ledgers,
  CustomReports,
  Reports,
} from "../layouts";

import { ROUTES, MANAGE_RKAAS_ROUTES, ApplicationRoute } from "../utils";

const menu = "rkaas";
export const ManageRkaasRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_RKAAS_ROUTES.INVESTMENT}
        component={Investment}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_RKAAS_ROUTES.ADD_INVESTMENT}/:investmentId?`,
          `${MANAGE_RKAAS_ROUTES.ADD_INVESTMENT}/:flow(add|edit|save)/:investmentId?`,
        ]}
        component={AddMasterInvestment}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_RKAAS_ROUTES.RKAS}
        component={RKAS}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_RKAAS_ROUTES.TRIAL_BALANCE}
        component={TrialBalance}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_RKAAS_ROUTES.LEDGERS}
        component={Ledgers}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_RKAAS_ROUTES.REPORTS}
        component={Reports}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_RKAAS_ROUTES.CUSTOM_REPORTS}
        component={CustomReports}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={MANAGE_RKAAS_ROUTES.CUSTODIAN}
        component={TradeCustodian}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          // `${MANAGE_RKAAS_ROUTES.ADD_CUSTODIAN}/:investmentId?`,
          `${MANAGE_RKAAS_ROUTES.ADD_CUSTODIAN}/:flow(add|edit|save)/:investmentId?`,
        ]}
        component={AddTradeCustodian}
      />
      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_RKAAS_ROUTES.CUSTODIAN_DETAIL}/:custodianId?`,
          //`${MANAGE_RKAAS_ROUTES.ADD_CUSTODIAN}/:flow(add|edit|save)/:custodianId?`,
        ]}
        component={CustodianDetail}
      />
      <Redirect exact from={ROUTES.RKAAS} to={MANAGE_RKAAS_ROUTES.CUSTODIAN} />
    </Switch>
  );
};
